import script from "./HardTime.vue?vue&type=script&setup=true&lang=js"
export * from "./HardTime.vue?vue&type=script&setup=true&lang=js"

import "./HardTime.vue?vue&type=style&index=0&id=c0785c08&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0785c08"]])

export default __exports__